import React from 'react';
import { Building2, MapPin, Shield } from 'lucide-react';
import LandingLayout, { useLandingMeta } from './LandingLayout';
import { GlassCard, SectionShell } from './LandingPrimitives';

const AboutPage = () => {
  useLandingMeta({
    title: 'About Us | Ground Aale',
    description: 'Ground Aale is a product of SARTECH — built to help sports ground owners run operations with clarity.',
    ogDescription: 'Learn about SARTECH and the team behind Ground Aale.',
  });

  return (
    <LandingLayout>
      <SectionShell id="top" className="pt-24 md:pt-28">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-ga-primary">About us</p>
        <h1 className="text-3xl font-bold leading-tight text-ga-text-primary md:text-4xl">Built by SARTECH for ground owners</h1>
        <p className="mt-4 max-w-3xl text-sm text-ga-text-muted md:text-base">
          Ground Aale is a sports facility management platform from SARTECH, an India-based technology company focused
          on practical software for real-world operators.
        </p>

        <div className="mt-8 grid gap-4 md:grid-cols-2">
          <GlassCard>
            <div className="flex items-start gap-3">
              <div className="shrink-0 rounded-lg bg-ga-green/20 p-2">
                <Building2 className="h-5 w-5 text-ga-primary" />
              </div>
              <div>
                <h2 className="text-sm font-semibold uppercase tracking-wide text-ga-text-primary">Our company</h2>
                <p className="mt-2 text-sm leading-relaxed text-ga-text-muted">
                  SARTECH builds and operates Ground Aale as a dedicated product for cricket grounds, academies, and
                  multi-sport facilities. We work directly with operators to solve booking chaos, staff coordination
                  gaps, and revenue tracking problems.
                </p>
              </div>
            </div>
          </GlassCard>

          <GlassCard>
            <div className="flex items-start gap-3">
              <div className="shrink-0 rounded-lg bg-ga-green/20 p-2">
                <Shield className="h-5 w-5 text-ga-primary" />
              </div>
              <div>
                <h2 className="text-sm font-semibold uppercase tracking-wide text-ga-text-primary">Registration</h2>
                <p className="mt-2 text-sm leading-relaxed text-ga-text-muted">
                  SARTECH is a registered MSME under Udyam. Ground Aale is offered as a commercial software product
                  for sports facility operators across India.
                </p>
              </div>
            </div>
          </GlassCard>

          <GlassCard className="md:col-span-2">
            <div className="flex items-start gap-3">
              <div className="shrink-0 rounded-lg bg-ga-green/20 p-2">
                <MapPin className="h-5 w-5 text-ga-primary" />
              </div>
              <div>
                <h2 className="text-sm font-semibold uppercase tracking-wide text-ga-text-primary">What we build</h2>
                <p className="mt-2 text-sm leading-relaxed text-ga-text-muted">
                  Ground Aale covers booking management, staff workflows, payments tracking, and operational reporting
                  — designed for owners who need one reliable system instead of WhatsApp threads and paper registers.
                </p>
              </div>
            </div>
          </GlassCard>
        </div>
      </SectionShell>
    </LandingLayout>
  );
};

export default AboutPage;
